// Small debug logger that only logs in development builds
export type DebugLogger = {
  log: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
};

export const dbg: DebugLogger = {
  log: (...args: unknown[]) => {
    // Always log in production for debugging invite flow
    // eslint-disable-next-line no-console
    console.log(...args);
  },
  warn: (...args: unknown[]) => {
    // Always log in production for debugging invite flow
    // eslint-disable-next-line no-console
    console.warn(...args);
  },
  error: (...args: unknown[]) => {
    // Always log in production for debugging invite flow
    // eslint-disable-next-line no-console
    console.error(...args);
  },
};






